import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

export const LandscapeNote = () => {
  return <Translation text={getFormedEltTranslation('landscape-note')} />
}
